import { Expose, Type } from 'class-transformer';
import { Brand } from './brand.model';
import { TruckType } from './truck-type.model';
import { Media } from '../../shared-features/models/media.model';
import { Status } from '../../shared-features/enums/shared-enums.enum';
import {
  AvlDeviceType,
  TruckClassify,
  TruckOperationStatus,
  TruckOwnershipType,
  TruckVerificationStatus,
} from '../../shared-features/enums/fleets.enum';
import { TruckDriverModel } from './truck-driver.model';
import { Fleet } from './fleet.model';
import { DropdownModel } from '@shared/models/dropdown-model.model';
import { StatusHistory } from './status-history.model';
import { StatusDaysCount } from './status-days-count.model';
import { PermittedAccess } from './permitted-access.model';
import { AVLGroup } from '../../live-tracking/models/avl-group.model';
import { AthrOperationCard } from './athr-card-model';
import { Vendors } from '../enums/vendors.enum';

export class Truck extends DropdownModel {
  @Expose() id: number;
  @Expose() manufactureYear: number;
  @Type(() => TruckType)
  @Expose()
  type: TruckType = new TruckType();
  @Type(() => Fleet)
  @Expose()
  fleet: Fleet = new Fleet();
  @Type(() => Brand)
  @Expose()
  brand: Brand = new Brand();
  @Type(() => TruckDriverModel)
  @Expose()
  driver: TruckDriverModel = new TruckDriverModel();
  @Expose() status: Status = Status.ACTIVE;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() createdBy: string;
  @Expose() plateNumber: string;
  @Expose() picture: Media = new Media();
  @Expose() sequenceNumber: number;
  @Expose() ownerName: string;
  @Expose() licenseExpiry: string;
  @Type(() => TruckDriverModel)
  @Expose()
  coDriver: TruckDriverModel = new TruckDriverModel();
  @Expose() weight: number;
  @Expose() volume: number;
  @Expose() ownershipType: TruckOwnershipType;
  @Expose() dailyPrice?: number;
  @Expose() operationStatus: TruckOperationStatus;
  @Type(() => StatusHistory)
  @Expose()
  statusHistory: StatusHistory = new StatusHistory();
  @Type(() => StatusDaysCount)
  @Expose()
  statusDaysCount: StatusDaysCount = new StatusDaysCount();
  @Expose() fileUri: string;
  @Expose() message: string;
  @Expose() permits: PermittedAccess[];
  @Expose() truckWorking: boolean;
  @Expose() avlDeviceId: string;
  @Expose() avlDeviceType: AvlDeviceType;
  @Expose() label: string;
  @Expose() plateNumberDetails: string;
  @Expose() ownerId: number;
  @Expose() isElmVerified: boolean;
  @Expose() temperatureControl: boolean;
  @Expose() classify: TruckClassify;
  @Expose() numOfPallets: number;
  @Expose() weightPercentage: number;
  @Expose() headWeight: number;
  @Expose() rentalDate: number;
  @Expose() isExternal: boolean;
  @Expose() driverName: string;
  @Expose() truckVerificationStatus: TruckVerificationStatus;
  avlGroup: AVLGroup = new AVLGroup();
  avlMobileNumber: string;
  @Expose() operationCard?: AthrOperationCard;
  @Expose() isVerifiedByAthr?: boolean;
  @Expose() externalAvlDeviceId: string;
  @Expose() isTrackedExternally: boolean;
  @Expose() withAvl: boolean;
  @Expose() externalTrackingService: Vendors;
  @Expose() uuid: string;
  @Expose() @Type(() => Media) licenseAttachment: Media;

  constructor() {
    super();
  }

  get truckType() {
    return this.type?.name;
  }

  get dropDownDisplayName(): string {
    return this.brand?.name
      ? this.brand?.name + ' - ' + this.type?.name + ' - ' + this.plateNumber
      : this.type?.name + ' - ' + this.plateNumber;
  }
  get dropDownValue(): object {
    return this;
  }
}
